import { configService } from '../modules/_core';

export * from './routes.constants';

export const googleApiClientId = '28956077136-ecdted18hdoi1cpuhkrsqdn320hm6227.apps.googleusercontent.com';
export const isGoogleAuthEnabled = true;
export const urlHash = '28956077136-ecdted18hdoi1cpuhkrsqdn320hm6227';

//export const googleApiClientId = '';
//export const isGoogleAuthEnabled = true;
